import { StarsIcon } from "@design-lab/shared/ui/icons";
import { ArtistEditsInfo } from "../ArtistEditsInfo";
import { PrintPerfectExplanatoryTooltip } from "./PrintPerfectExplanatoryTooltip";

type ArtistEditsHeaderProps = {
  title: string;
};

export function ArtistEditsHeader({ title }: ArtistEditsHeaderProps) {
  return (
    <div className="flex items-center gap-1.5">
      <StarsIcon className="size-6" />
      <span className="text-sm font-medium leading-6 text-neutral-950">{title}</span>
      <span className="rounded-full border border-white bg-green-700 px-1.5 py-0.5 text-xs font-medium text-white">
        Free
      </span>
      <div className="flex flex-1 justify-end">
        <PrintPerfectExplanatoryTooltip label="How it works" centeredMobile>
          <ArtistEditsInfo />
        </PrintPerfectExplanatoryTooltip>
      </div>
    </div>
  );
}
